import React from 'react';
import PropTypes from 'prop-types';


import ProductCard from 'Components/Blog/content/slices/ProductCard';
import Gleam from 'Components/Blog/content/slices/Gleam';
import SurveyMonkey from 'Components/Blog/content/slices/SurveyMonkey';
import ImageGallery from 'Components/Blog/content/slices/ImageGallery';
import Video from 'Components/Blog/content/slices/Video';
import RepeatingSlice from 'Components/Blog/content/slices/_RepeatingSlice';

export default function BlogSlice({ body }) {
  switch (body.slice_type) {
    case 'text':
      return <RepeatingSlice body={body} />;
    case 'image_gallery':
      return <RepeatingSlice body={body} Component={ImageGallery} />;
    case 'gleam_widget': // Named this way in prismic, too late to change
      return <RepeatingSlice body={body} Component={Video} />;
    case 'contest':
      return <RepeatingSlice body={body} Component={Gleam} />;
    case 'survey_monkey':
      return <SurveyMonkey body={body} />;
    case 'product_card':
      return <ProductCard body={body} />;
    default:
      return <div className={`missing-blog-slice ${body.slice_type}`} />;
  }
}

BlogSlice.propTypes = {
  body: PropTypes.shape({
    slice_type: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    primary: PropTypes.shape({}),
  }).isRequired,
};
